
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contents",
      function () {
        return require("private-next-pages/contents/index.tsx");
      }
    ]);
  